import { Dispatch } from "redux";
import {
    PostPaymantPawapayAction,
    PostPaymantPawapayActionTypes
} from "../../types/Payments/postPaymentPawapayTypes";
import axios from "axios";

interface ErrorResponse {
    code: number;
    message: string;
}

interface PawapayRequest {
    name: string;
    account: string;
    bank: string;
}

export const postPawapayPaymentInfo = (payload: PawapayRequest, ticketCode: string) => {
    return async (dispatch: Dispatch<PostPaymantPawapayAction>) => {
        try {
            dispatch({ type: PostPaymantPawapayActionTypes.POST_PAWAPAY_PAYMENT_DATA });
            const response = await axios.post(
                `/api/claim/${ticketCode}`,
                payload
            );

            dispatch({
                type: PostPaymantPawapayActionTypes.POST_PAWAPAY_PAYMENT_DATA_SUCCESS,
                payload: {responseStatus: response.status}
            });

        } catch (error: any) {
            let errorPayload: ErrorResponse;

            if (error.response?.data) {
                if (typeof error.response.data === 'string') {
                    errorPayload = {
                        code: error.response.status,
                        message: error.response.data,
                    };
                } else {
                    errorPayload = {
                        code: error.response.status,
                        message: error.response.data.detail || 'Operator error',
                    };
                }
            } else {
                errorPayload = {
                    code: -1,
                    message: 'Unknown error occurred'
                };
            }

            dispatch({
                type: PostPaymantPawapayActionTypes.POST_PAWAPAY_PAYMENT_DATA_ERROR,
                payload: errorPayload
            });
        }
    };
};